import CreditCardIcon from "../../../../assets/icons/CreditCard";
import DeliveryIcon from "../../../../assets/icons/Delivery";
import OperatorIcon from "../../../../assets/icons/Operator";
import "./BannerInfo.scss";

const ItemInfo = ({
  icon,
  title,
  description,
}: {
  icon: JSX.Element;
  title: string;
  description: string;
}) => {
  return (
    <div className="item-info">
      <div>{icon}</div>
      <div>
        <div>{title}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};

const BannerInfo = () => {
  const items = [
    {
      icon: <DeliveryIcon />,
      title: "LIVRAISON RAPIDE ET GRATUITE",
      description: "Dès 300 € d’achat en IDF et 500 € en France",
    },
    {
      icon: <CreditCardIcon />,
      title: "PAIEMENT SÉCURISÉ",
      description: "Via compte client et carte bancaire",
    },
    {
      icon: <OperatorIcon />,
      title: "SERVICE CLIENT",
      description:
        "Du lundi au jeudi de 8h à 12h30 et de 13h30 à 17h. Vendredi, fermeture à 16h",
    },
  ];
  return (
    <div className="banner-info">
      {items.map((item, idx) => (
        <ItemInfo key={`${idx}-banner-info`} {...item} />
      ))}
    </div>
  );
};
export default BannerInfo;
